import { createSlice } from "@reduxjs/toolkit";

const networkSlice = createSlice({
  name: "network",
  initialState: {
    isOnline: typeof navigator !== "undefined" ? navigator.onLine : true,
  },
  reducers: {
    setOnline(state, action) {
      state.isOnline = Boolean(action.payload);
    },
  },
});

export const { setOnline } = networkSlice.actions;

export const selectIsOffline = (state) => state.network?.isOnline === false;

export default networkSlice.reducer;
